import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import { defineMessages, injectIntl, intlShape } from 'react-intl';

import Icon from '../../common/Icon';

const messages = defineMessages({
  categorySliderNext: {
    id: 'navigation.categorySliderNext',
    defaultMessage: 'Scroll product categories right',
  },
  categorySliderPrevious: {
    id: 'navigation.categorySliderPrevious',
    defaultMessage: 'Scroll product categories left',
  },
});

const CategorySliderControls = ({
  intl,
  canScrollLeft = true,
  canScrollRight = true,
  onScrollLeft,
  onScrollRight,
}) => {
  return (
    <div className="CategorySliderControls">
      <Button
        color="secondary"
        onClick={onScrollLeft}
        disabled={!canScrollLeft}
        aria-label={intl.formatMessage(messages.categorySliderPrevious)}
      >
        <Icon name="chevron-left" />
      </Button>
      <Button
        color="secondary"
        onClick={onScrollRight}
        disabled={!canScrollRight}
        aria-label={intl.formatMessage(messages.categorySliderNext)}
      >
        <Icon name="chevron-right" />
      </Button>
    </div>
  );
};

CategorySliderControls.propTypes = {
  intl: intlShape.isRequired,
  canScrollLeft: PropTypes.bool,
  canScrollRight: PropTypes.bool,
  onScrollLeft: PropTypes.func.isRequired,
  onScrollRight: PropTypes.func.isRequired,
};

export default injectIntl(CategorySliderControls);
